import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AutenticacaoService } from '../services/autenticacao.service';

export const USE_TOKEN = new HttpContextToken<boolean>(() => true);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private auth: AutenticacaoService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.auth.getToken())
      .pipe(
        map(token => {
          if (!req.context.get(USE_TOKEN))
            return req;

          if (token) {
            return req.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            });
          }

          return req;
        }),
        switchMap(req => next.handle(req)),
        catchError((err) => {
          console.error(err);
          if (err instanceof HttpErrorResponse && err.status === 403 && err.error.mensagem == 'Acesso negado!') {
            return this.handle403Error(req, next);
          }

          return throwError(() => err);
        })
      );
  }

  private handle403Error(req: HttpRequest<any>, next: HttpHandler) {
    return from(this.auth.expirarToken())
      .pipe(
        switchMap(async () => Promise.reject(new Error('Token expirado!')))
      );

    // return from(this.auth.refreshToken())
    //   .pipe(
    //     switchMap(async () => {
    //       const token = await this.auth.getToken();
    //       return req.clone({
    //         setHeaders: {
    //           Authorization: `Bearer ${token}`
    //         }
    //       });
    //     }),
    //     switchMap((request) => next.handle(request))
    //   );
  }

}
